import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/general-surgery-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function GeneralSurgery() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "General Surgery");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        {/* Navbar starts here  */}

            <Navbar />

        {/* Navbar ends here */}

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>General, Minimal Access & Bariatric Surgery (General Surgery)</p>
                
                <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                    <p className="page-subtitle">
                        Specialized Surgical Treatments Encompassing General,
                        <br/>
                        Minimal Access, and Bariatric Procedures.
                    </p>
                </div>

                <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                        Specialized Surgical Treatments Encompassing General, Minimal Access, and Bariatric Procedures.
                    </p>
                </div>

                <div className="page-box">
                    <div className="box-content">
                        <p>Caritas Matha Hospital's General, Minimal Access & Bariatric Surgery department specializes in advanced surgical interventions, including minimally invasive and bariatric surgeries. Our expert team provides personalized care using state-of-the-art technology and evidence-based practices to ensure optimal patient outcomes.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="General Surgery Banner"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="dept-section">
            <div
            ref={sidebarRef}
            className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
            >
            {["overview", "treatment", "facilities", "doctors"].map((section) => (
                <p
                key={section}
                className={`title ${activeSection === section ? "active" : ""}`}
                onClick={() => scrollToSection(section)}
                >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                {activeSection === section && (
                    <FontAwesomeIcon
                    icon={faChevronRight}
                    className="chevron-icon"
                    />
                )}
                </p>
            ))}
            </div>
            <div ref={contentRef} className="contents">
                <div ref={sectionsRef.overview} className="overview-content">
                    <p className="content-heading">Overview</p>
                    {/* Overview content here */}
                    <p>The General, Minimal Access & Bariatric Surgery (General Surgery) department at Caritas Matha Hospital is renowned for its advanced surgical care and comprehensive support for patients with acute illnesses or injuries, employing a multidisciplinary approach. Our team, composed of highly experienced surgeons, excels in handling complex cases with evidence-based medical care and state-of-the-art technical support, adhering to global treatment protocols.</p>

                    <p>We prioritise patient-centred care, ensuring each individual receives personalised attention and tailored treatment plans. From the initial consultation to post-operative care, our compassionate staff is dedicated to supporting patients and their families every step of the way. We understand the anxiety and concerns associated with surgical procedures, and strive to provide a supportive environment that fosters confidence and trust.</p>

                    <p>At Caritas Matha Hospital, we continuously invest in cutting-edge technology and medical advancements to enhance surgical outcomes and patient recovery. Our modern facilities include advanced surgical theaters equipped for both major open surgeries and minimally invasive procedures. We emphasize the importance of comprehensive pre-operative assessments and thorough post-operative care, ensuring optimal recovery and long-term health for our patients.</p>

                </div>
                <div ref={sectionsRef.treatment} className="treatment-content">
                    <p className="content-heading">Treatment</p>
                    {/* Treatment content here */}
                    
                    
                    <p>Our department provides a wide range of services : </p>
                    <ul>

                        <li><span className="subtitle">Comprehensive General Surgical Services : </span>Two units ensure integrated, all-round surgical care, supported by dedicated anesthesiology and critical care teams. </li>
                        <br/>
                        
                        <li><span className="subtitle">Head and Neck Surgery : </span>Includes procedures for thyroid, parotid, and neck nodes.</li>
                        <br/>

                        <li><span className="subtitle">Breast Surgery : </span>Options such as conventional mastectomy, breast reconstruction,breast-conserving surgery, and oncoplastic breast surgery.</li>
                        <br/>

                        <li><span className="subtitle">Emergency Surgical Services : </span>Available round the clock for urgent medical needs.</li>
                        <br/>

                        <li><span className="subtitle">Laparoscopic Procedures : </span>Basic and advanced laparoscopic surgeries for various conditions.</li>
                        <br/>

                        <li><span className="subtitle">Gastrointestinal Surgeries : </span>Both open and laparoscopic procedures for gastrointestinal issues.</li>
                        <br/>

                        <li><span className="subtitle">Integrated Breast Care Programs : </span>Covering clinical examinations, FNAC, Mammography, and comprehensive breast surgeries.</li>
                        <br/>

                        <li><span className="subtitle">Hemorrhoid Management : </span>Includes open surgery, stapler hemorrhoidectomy, banding,Laser treatment and infrared coagulation.</li>
                        <br/>

                        <li><span className="subtitle">Diabetic Foot Management : </span>Comprehensive podiatry services for care of diabetic foot issues.</li>
                        <br/>

                        <li><span className="subtitle">Varicose Vein Surgery : </span>Laser Treatment options for varicose veins.</li>
                        <br/>

                        <li><span className="subtitle">Hernia Surgeries : </span>Both open and laparoscopic approaches for hernia repair.</li>
                        <br/>

                        <li><span className="subtitle">Pilonidal Sinus Surgery : </span>Surgical options including excision and multiple Z-plasty.</li>
                        <br/>

                        <li><span className="subtitle">Obesity Clinic : </span>Offers dietary advice, exercise training, psychotherapy, and bariatric surgery with a dedicated team specializing in weight management. </li>
                        <br/>

                    </ul>

                </div>
                <div ref={sectionsRef.facilities} className="facilities-content">
                    <p className="content-heading">Facilities</p>
                    {/* Facilities content here */}

                    <br/>
                    <ul>
                        <li><span className="subtitle">Modern Surgical Operation Theaters : </span>Equipped with advanced technology for precise surgical interventions.</li>
                        <br/>

                        <li><span className="subtitle">Outpatient Services : </span>Convenient access to consultations, diagnostic tests, and minor procedures.</li>
                        <br/>

                        <li><span className="subtitle">Inpatient Care : </span>Comfortable wards and private rooms for post-operative recovery and specialized medical care.</li>
                        <br/>

                        <li><span className="subtitle">Emergency Care Unit : </span>24/7 availability of emergency surgical services and critical care support.</li>
                        <br/>

                        <li><span className="subtitle">Diagnostic Services : </span>Comprehensive diagnostic facilities including imaging (X-ray, CT scan) and laboratory services.</li>
                        <br/>

                        <li><span className="subtitle">Specialized Clinics : </span>Dedicated clinics for obesity management, diabetic foot care, and other specialized services.</li>
                        <br/>

                        <li><span className="subtitle">Patient Support Services : </span>Counseling, education, and rehabilitation services to support patients throughout their treatment journey.</li>
                        <br/>

                        <li><span className="subtitle">Expert Anesthesiology and Critical Care Teams : </span>Ensuring safety and optimal outcomes during surgical procedures and recovery.</li>
                        <br/>
                    </ul>

        
                </div>

                <div ref={sectionsRef.doctors} className="doctors">
                    <p className="content-heading">Doctors</p>

                    {error && <p>{error}</p>}
                    {filteredDoctors.length > 0 ? (
                        <div className='doctorbox-container'>
                            {filteredDoctors.map(doctor => (
                              <div key={doctor.id} className="doctorbox">
                                <div className="doctor-box">
                                    <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    <div className='doctor-details'>
                                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                        <p>{doctor['designation']}</p>
                                        <p>{ doctor.available_time }</p>
                                        <br/>
                                        {parseInt(doctor.appointment_enabled) === 1 && (
                                            <p>
                                                <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                    Book An Appointment <FaChevronRight />
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='arrow-section'>
                                    <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                </div>
                              </div>
                            ))}
                        </div>
                    ) : (
                        !error && <p>No doctors available in this department.</p>
                    )}
                </div>
            </div>
        </section>

        {/* Footer Starts here */}

            <Footer ref={footerRef} />

        {/* Footer ends here */}
    </div>
  );
}

export default GeneralSurgery;